module.exports = __webpack_public_path__ + "media/members/merge-4d452236.svg";